<template>
    <activation-brief-task-delivery-instagram-story-provider
        v-slot="{
            brief,
            contact,
            step,
            task,
            deliverable,
            errors,
            errorMessage,
            isLoading,
            deliverStoryUrl,
            deliverInsightsUrl,
            uploadHeaders,
            isDeliverableComplete,
            handleInsightsFileChange,
            handleStoryFileChange,
            deliverableHasInsights,
            handleStartConnection,
            hasUploadedFiles,
            uploadedFiles,
            isTaskContentLoading,
            taskContent,
            quantityString,
            handleReloadTaskContent
        }"
        style="height: 100%"
    >
        <activation-brief-task-delivery-instagram-story-view
            :brief="brief"
            :contact="contact"
            :step="step"
            :task="task"
            :deliverable="deliverable"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :deliver-story-url="deliverStoryUrl"
            :deliver-insights-url="deliverInsightsUrl"
            :upload-headers="uploadHeaders"
            :is-deliverable-complete="isDeliverableComplete"
            :deliverable-has-insights="deliverableHasInsights"
            :has-uploaded-files="hasUploadedFiles"
            :uploaded-files="uploadedFiles"
            :is-task-content-loading="isTaskContentLoading"
            :task-content="taskContent"
            :quantity-string="quantityString"
            @story-file-change="handleStoryFileChange"
            @insights-file-change="handleInsightsFileChange"
            @start-connection="handleStartConnection"
        />
    </activation-brief-task-delivery-instagram-story-provider>
</template>

<script>
    import ActivationBriefTaskDeliveryInstagramStoryProvider from '../providers/activation-brief-steps/ActivationBriefTaskDeliveryInstagramStoryProvider.vue';
    import ActivationBriefTaskDeliveryInstagramStoryView from '../data-views/activation-briefs/partials/tasks/ActivationBriefTaskDeliveryInstagramStoryView.vue';

    export default {
        name: 'ActivationBriefTaskDeliveryInstagramStoryRouterView',
        components: {
            ActivationBriefTaskDeliveryInstagramStoryView,
            ActivationBriefTaskDeliveryInstagramStoryProvider
        }
    };
</script>
